import {Typography} from "@mui/material";

export const CdpvInfoContent = (selectorContractGridAPI) => {


    switch(selectorContractGridAPI) {

        case 'Dashboard':
            return {
                title: 'Returned Data Points',
                content: 'Select the Data Points that you want to see on the Dashboard.  ' +
                    'Choose the order in which they will display.'
            };

        default:
            // case 'Drilldown':
            return {
                title: 'Contract Data Point Values',
                content: (
                    <>
                        <Typography paragraph>
                            Contract Data Point Values are required for any
                            Contract Data Point.
                        </Typography>

                        <ul>
                            <li>
                                They can have a Value, a logical Expression,
                                or be blank until a user adds a value.
                            </li>

                            <li>
                                They can be numbers, percentages, free text,
                                dates, etc., depending on the Data Type of
                                the Data Point assigned to the Contract
                                Data Point.
                            </li>

                            <li>
                                One or many Contract Data Point Values
                                can be assigned to a Contract Data Point.
                            </li>

                            <li>
                                They can also be set to automatically
                                build more of themselves during calculations
                                if the Extend Indicator is set to Yes.
                            </li>

                            <li>
                                Only assign an Order or Iteration Number
                                if you will add many or if you are extending.
                            </li>

                            <li>
                                One or more Contract Data Point Values
                                can be assigned to a Contract Data Point
                                Value Filter to direct the situations
                                when it will be added to an individual
                                contract model.
                            </li>

                            <li>
                                An Origin must be assigned.
                            </li>

                            <li>
                                Only Contract Data Points with an Origin
                                of "Input" or "Assumption" can be edited
                                in an individual contract model.
                            </li>
                        </ul>
                    </>
                )
                // return {
                //     title: 'Contract Data Point Values',
                //     content: 'Contract Data Point Values are required for any Contract Data Point.  ' +
                //         'They can have a Value, a logical Expression, or be blank until a user adds a value.  ' +
                //         'They can be numbers, percentages, free text, dates, etc., depending on the Data Type of the Data Point assigned' +
                //         ' to the Contract Data Point. One or many Contract Data Point Values can be assigned to a Contract Data Point.  ' +
                //         'They can also be set to automatically build more of themselves during calculations if the Extend Indicator is set to Yes.  ' +
                //         'Only assign an Order or Iteration Number if you will add many or if you are extending.  ' +
                //         'One or more Contract Data Point Values can be assigned to a Contract Data Point Value Filter to direct the ' +
                //         'situations when it will be added to an individual contract model. ' +
                //         'An Origin must be assigned.  Only Contract Data Points with an Origin of "Input" or "Assumption" can be edited' +
                //         'in an individual contract model.  '
                // };
            }}

};